import { InjectionToken } from '@angular/core';
import { AuthClientSettings } from './auth-client-settings';

export const AUTH_CLIENT_SETTINGS = new InjectionToken<AuthClientSettings>(
  'AuthClientSettings'
);
